<template>
  <div>
    <div class="d-flex justify-content-center py-4" v-if="isLoading">
      <loader/>
    </div>
    <notification-message
      message="Parece que aún no agregas publicaciones" v-if="posts.length == 0 && !isLoading" 
    />
    <div class="main-content-container container-fluid px-4">
      <div>

        <div class="page-header row no-gutters py-4" v-if="!isLoading">
          <div class="col-12 col-sm-6 text-center text-sm-left mb-4 mb-sm-0">
            <span class="text-uppercase page-subtitle">Publicaciones</span>
            <h3 class="page-title">Visión general</h3>
          </div>
          <div class="col-12 col-sm-6 d-flex align-items-center">
            <div class="d-none d-md-inline-flex mb-sm-0 mx-auto ml-sm-auto mr-sm-0" role="group" aria-label="Page actions">
              <router-link to="agregar/publicacion" id="add-new-event" class="btn btn-primary">
                <i class="fas fa-plus"></i> 
                Publicación 
              </router-link>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-12 mb-4" v-for="(post, index) in posts" :key="index">
            <div class="card card-small card-post card-post--1">
              <div class="card-post__image" :style="'background-image: url('+ post.image +');'">
                <span href="#" class="card-post__category badge badge-pill badge-dark">
                  {{ post.category }}
                </span>
                <div class="card-post__author d-flex">
                  <span href="#" :title="post.author" class="card-post__author-avatar card-post__author-avatar--small" :style="'background-image: url('+post.user_photo+');'"></span>
                </div>
              </div>
              <div class="card-body">
                <h5 class="card-title">
                  <a class="text-fiord-blue" href="#">
                    {{ post.name }}
                  </a>
                </h5>
                <p class="card-text d-inline-block mb-3">
                  {{ post.excerpt }}
                </p>
                <span class="text-muted d-block">
                  <convert-date :date="post.date"/>
                </span>
              </div>
              <div class="card-footer border-top text-primary">
                <span class="badge badge-secondary mr-2" @click.prevent="deleteOption(post.id, index)">
                  <i class="fas fa-trash"/>
                </span>
                <router-link :to="'/publicacion/' + post.slug">
                  <span class="badge badge-secondary"><i class="fas fa-edit"></i></span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import NotificationMessage from '@/components/general/NotificationMessage';
  export default {
    components: { NotificationMessage },
    data() {
      return {
        isLoading: true,
        posts: []
      }
    },

    mounted() {
      this.getProjects();
    },

    methods: {
      async getProjects() {
        let url = process.env.VUE_APP_ROOT_API.concat('/post/card');
        let response = await fetch(url);
        this.posts = await response.json(); 
        if(response.status == 200) {
          this.isLoading = false;
        }
      },

      deleteOption(id, index) {
        const message = '¿Quieres eliminar esta publicación?';
        const options = {
          okText: 'Sí',
          cancelText: 'No'
        };
        let that = this;
        this.$dialog
          .confirm(message, options)
          .then(function(dialog) {
            that.deleteProject(id, index);
          });
      },

      async deleteProject(id, index) {
        let url = process.env.VUE_APP_ROOT_API.concat(`/post/hide/${id}`);
        let settings = {
          method: 'POST'
        };
        let response = await fetch(url, settings);
        if(response.status == 200) {
          this.posts.splice(index, 1);
          console.log('Se ha eliminado satisfactoriamente');
        }

      }
    }
  } 
</script>